import React from "react";
import { useTranslation } from "react-i18next";
import Accordion from 'react-bootstrap/Accordion';

const FAQ: React.FC = () => {
  const { t } = useTranslation();

  return (
    <section id="faqs" className="banner neumorphic-container rounded-0 d-block justify-content-center align-items-center col-lg-12 mb-0 p-5">
      <div className="container col-lg-12">
        <h2 className="text-center">{t("faq.title")}</h2>
        <h3 className="text-center">{t("faq.subtitle")}</h3>
        <p className="text-center">{t("faq.description")}</p>
      </div>
      <div className="d-flex justify-content-center align-items-center col-lg-12">
        <Accordion defaultActiveKey="-1" className="col-12 col-lg-8 rounded-3">
          <Accordion.Item eventKey="6" className="mb-3 rounded-4">
            <Accordion.Header className="neumorphic-container">{t("faq.q12")}</Accordion.Header>
            <Accordion.Body className="neumorphic-container mt-3">{t("faq.a12")}</Accordion.Body>
          </Accordion.Item>
          <Accordion.Item eventKey="0" className="mb-3 rounded-4">
            <Accordion.Header className="neumorphic-container">{t("faq.q1")}</Accordion.Header>
            <Accordion.Body className="neumorphic-container mt-3">{t("faq.a1")}</Accordion.Body>
          </Accordion.Item>
          <Accordion.Item eventKey="1" className="mb-3 rounded-4">
            <Accordion.Header className="neumorphic-container">{t("faq.q2")}</Accordion.Header>
            <Accordion.Body className="neumorphic-container mt-3">{t("faq.a2")}</Accordion.Body>
          </Accordion.Item>
          <Accordion.Item eventKey="2" className="mb-3 rounded-4">
            <Accordion.Header className="neumorphic-container">{t("faq.q3")}</Accordion.Header>
            <Accordion.Body className="neumorphic-container mt-3">{t("faq.a3")}</Accordion.Body>
          </Accordion.Item>
          <Accordion.Item eventKey="3" className="mb-3 rounded-4">
            <Accordion.Header className="neumorphic-container">{t("faq.q4")}</Accordion.Header>
            <Accordion.Body className="neumorphic-container mt-3">{t("faq.a4")}</Accordion.Body>
          </Accordion.Item>
          <Accordion.Item eventKey="4" className="mb-3 rounded-4">
            <Accordion.Header className="neumorphic-container">{t("faq.q5")}</Accordion.Header>
            <Accordion.Body className="neumorphic-container mt-3">{t("faq.a5")}</Accordion.Body>
          </Accordion.Item>
          <Accordion.Item eventKey="5" className="mb-3 rounded-4">
            <Accordion.Header className="neumorphic-container">{t("faq.q6")}</Accordion.Header>
            <Accordion.Body className="neumorphic-container mt-3">{t("faq.a6")}</Accordion.Body>
          </Accordion.Item>
        </Accordion>
      </div>
    </section>
  );
}

export default FAQ;
